
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EntityContainerModel } from '../../../../../../models/aggregates/erp/entity';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { EntityQueryCriteriaClass, EntityCriteriaModelQuery } from '../../../criteria/entity-criteria.model';
import { ApiResponseModel } from '../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class MerchantService extends BaseApiTemplateService<EntityContainerModel> {
  publicpoint_path: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/merchants';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/merchants';
    this.publicpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity';
    this.httpClient = http;
  }

  getMerchantByCriteria(visa: ApiVisa, criteria?: EntityQueryCriteriaClass):
    Observable<ApiResponseModel<EntityContainerModel>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
    const buildEntityCriteriaCriteria = new EntityCriteriaModelQuery(criteria);
    return this.httpClient.get<ApiResponseModel<EntityContainerModel>>(this.apiUrl + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }

  uploadImageAndDetails(formData: FormData, file_type: string, hdrGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + hdrGuid + '?file-type=' + file_type;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + hdrGuid + '?file-type=' + file_type;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa)); 
  }

  deleteImageAndDetails(extGuid: string, visa: ApiVisa){
    let url = this.publicpoint_path + "/file/" + extGuid;
    if (this.publicpoint_path && visa.api_domain_url){
      url = visa.api_domain_url + this.publicpoint_path + "/file/" + extGuid;
    }
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  getExtDetailsByGuid(extGuid: string, visa: ApiVisa) {
    let url = this.publicpoint_path + "/file/" + extGuid;
    if (this.publicpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.publicpoint_path + "/file/" + extGuid;
    }
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  getByGuidLoginAndWebsiteEp(websiteGuid: string, guid: string, visa: ApiVisa) {
    let url = this.endpoint_path + '/' + guid + '/website-ep/' + websiteGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/' + guid + '/website-ep/' + websiteGuid;
    }
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

}
